import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import { EMPTY_OBJECT } from '../../../constants/common'
import { RadioGroupModal } from '../../Radio'
import { isDraftOpenAction } from '../Draft.utils'

import {
  DRAFT_CREATE_ACTION_SELECT_MODAL_FIELD_ACTION,
  DRAFT_CREATE_ACTION_SELECT_MODAL_INITIAL_VALUES,
} from './DraftCreateActionSelectModal.constants'
import { getDraftCreateActionSelectModalOptions } from './DraftCreateActionSelectModal.utils'

function DraftCreateActionSelectModal({
  createNewLabelKey,
  draft,
  formFieldsProps: {
    titleKey: formFieldsTitleKey,
    ...formFieldsProps
  } = EMPTY_OBJECT,
  initialValues,
  openDraftLabelKey,
  submitTextKey,
  titleKey,
  onCancel,
  onSubmit,
  ...modalProps
}) {
  const { t } = useTranslation()

  const getOptions = useCallback(
    () =>
      getDraftCreateActionSelectModalOptions({
        createNewLabelKey,
        openDraftLabelKey,
        t,
      }),
    [createNewLabelKey, openDraftLabelKey, t]
  )

  const handleSubmit = useCallback(
    ({ [DRAFT_CREATE_ACTION_SELECT_MODAL_FIELD_ACTION]: action }) => {
      const isOpenDraft = isDraftOpenAction(action)

      onSubmit?.({
        action,
        initialValues: isOpenDraft ? draft : initialValues,
      })
    },
    [draft, initialValues, onSubmit]
  )

  return (
    <RadioGroupModal
      {...modalProps}
      formFieldsProps={{
        ...formFieldsProps,
        getOptions,
        name: DRAFT_CREATE_ACTION_SELECT_MODAL_FIELD_ACTION,
        submitProps: {
          ...formFieldsProps.submitProps,
          title: submitTextKey,
        },
        title: t(formFieldsTitleKey),
      }}
      initialValues={DRAFT_CREATE_ACTION_SELECT_MODAL_INITIAL_VALUES}
      title={t(titleKey)}
      onCancel={onCancel}
      onClose={onCancel}
      onSubmit={handleSubmit}
    />
  )
}

export default DraftCreateActionSelectModal
